import { render, staticRenderFns } from "./ReporteTarifas.vue?vue&type=template&id=892b5b5c"
import script from "./ReporteTarifas.vue?vue&type=script&lang=js"
export * from "./ReporteTarifas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports